export class PlatformLanguageCode {
  $id?: number | null = 0;
  $type?: any | null | undefined;
  id: number | null = 0;
  externalId: number | null = 0;
  value: string | null = null;
  label: string | null = null;
  rfc5646: string | null = null;
  valueObject?: any | null = null;
  constructor(init?: Partial<PlatformLanguageCode>) {
    Object.assign(this, init);
  }
}
